import Emoji from "@core-components/emoji/Emoji";
import ReviewCarousel from "@core-components/reviews/ReviewCarousel";
import type { IReview } from "@core-components/reviews/model/IReview";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import ValorantGradientText from "./ValorantGradientText";

import useAppTranslation from "@hooks/language/useAppTranslation";

const ValorantReviewCarousel = () => {
  const { t } = useAppTranslation("pages.valorant.reviews");
  const reviewComments = t("items", { returnObjects: true }) as {
    comment: string;
  }[];

  const reviews: IReview[] = [
    {
      author: "XIVNE",
      comment: reviewComments[0].comment,
      grade: 5,
      url: "https://fr.trustpilot.com/reviews/6751d7d0d1ff9a9dccaddd7f",
    },
    {
      author: "MAROUAN BOI",
      comment: reviewComments[1].comment,
      grade: 5,
      url: "https://fr.trustpilot.com/reviews/674a82408ab345edec4e0cfc",
    },
    {
      author: "SHARKMAP",
      comment: reviewComments[2].comment,
      grade: 5,
      url: "https://fr.trustpilot.com/reviews/673f4c8080d76759aba74647",
    },
    {
      author: "EKZ",
      comment: reviewComments[3].comment,
      grade: 5,
      url: "https://fr.trustpilot.com/reviews/6745c7b5f32374312ee3c6bd",
    },
  ];

  const headline = (
    <>
      <Emoji.ThumbUp size={20} />
      <SSWhiteText> {t("headline.prefix")} </SSWhiteText>
      <ValorantGradientText>{t("headline.suffix")}</ValorantGradientText>
    </>
  );

  return (
    <ReviewCarousel
      className="gap-5"
      reviews={[...reviews, ...reviews]}
      headline={headline}
    />
  );
};

export default ValorantReviewCarousel;
